module.exports = __webpack_public_path__ + "img/BM.d1c8883d.svg";